import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';

import { createContexts } from '../../utils';

import type { EventDefinition } from '../../types';

export const ask_klue_interaction: EventDefinition = {
  getData: (action, eventData = {}) => ({
    type: action,
    ...pick(eventData, [
      'id',
      'appType',
      'text',
      'threadId',
      'page',
      'textFeedback',
      'isAskKlueFeedbackDialog',
      'isResearchMode',
    ]),
  }),
  addContexts: ({ action, eventData } = {}) => {
    if (
      action === 'render_ask_suggest' &&
      eventData?.askKlueSuggest &&
      !isEmpty(eventData.askKlueSuggest)
    ) {
      return eventData.askKlueSuggest.flatMap((suggest: any) =>
        createContexts(['ask_klue_suggest', 'board'], {
          eventData: {
            ask_klue_suggest: {
              template: suggest.template,
              text: suggest.text,
            },
            board: {
              id: parseInt(suggest.rivalId),
              idType: 'rival',
              viewOrder: suggest.rivalRank,
            },
          },
        }),
      );
    }
    return [];
  },
};
